var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:("transaction_button-" + _vm.color),attrs:{"size":_vm.size,"icon":_vm.icon,"plain":_vm.isPlain},on:{"click":function($event){$event.preventDefault();return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }